// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"670":"9b8b43916b33fb9c","2409":"23adbb4dfd3897ac","3185":"abdb89b3ece91a86","3650":"73740752903dd7ae","6889":"7520de0543d512a3"}[chunkId] + ".css";
};